
import axios from 'axios'
import { url } from './url'

function getPartners() {
    var urlString = `${url}/partner`;
    return axios
        .get(urlString)
        .then(res => res.data);
}
function getCustomers(params) {
    var urlString = `${url}/customer`;
    console.log(params)
    return axios
        .get(urlString,{params:params})
        .then(res => res.data);
}
function updatePartner(form) {
    return axios.put(`${url}/partner/${form._id}/`,form)
        .then(resp => {
            return resp.data
        })
}
function getOnePartners(id) {
    return axios.get(`${url}/partner/${id}`)
        .then(resp => {
            return resp.data
        })
}

function createPartner(partner){
    return axios.post(`${url}/partner`,partner)
    .then(resp => {
        return resp.data
    })
}

export default {
    getPartners,
    getOnePartners,
    createPartner,
    getCustomers,
    updatePartner,
    
};